module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/portable-related-2.png";